/**
 * ### [Route for ('/projects')]
 *
 * Shows the list of projects using tables along with the filters and expandable rows
 */

import { GenericTableFactory } from "../../_Shared/Table/Classes/Factory";
import { RouteButton } from "../../Buttons";

export function ProjectList() {
	const table = GenericTableFactory.createProjectTable("all");

	return (
		<>
			<div className="pt-5 pl-5">
				<h1>Projects</h1>
			</div>

			{table.RenderTable()}

			<div className="flex flex-row justify-center gap-3 m-2">
				<RouteButton route={"/main_menu"} text="Back" />
			</div>
		</>
	);
}

export function UsersProjectsList() {
	const table = GenericTableFactory.createProjectTable("personal");

	return (
		<>
			<div className="pt-5 pl-5">
				<h1>Projects</h1>
			</div>

			{table.RenderTable()}

			<div className="flex flex-row justify-center gap-3 m-2">
				<RouteButton route={"/main_menu"} text="Back" />
			</div>
		</>
	);
}

export function MiniProjectList() {
	const table = GenericTableFactory.createProjectTable("mini");

	return <>{table.RenderTable()}</>;
}

export function MiniCASProjectList() {
	const table = GenericTableFactory.createProjectTable("mini-cas");

	return <>{table.RenderTable()}</>;
}

export function FinanceProjectList() {
	const table = GenericTableFactory.createProjectTable("finance");

	return (
		<>
			<div className="pt-5 pl-5">
				<h1>Projects</h1>
			</div>

			{table.RenderTable()}

			<div className="flex flex-row justify-center gap-3 m-2">
				<RouteButton route={"/main_menu"} text="Back" />
			</div>
		</>
	);
}

export function CASProjectList() {
	const table = GenericTableFactory.createProjectTable("cas");

	return (
		<>
			<div className="pt-5 pl-5">
				<h1>Projects</h1>
			</div>

			{table.RenderTable()}

			<div className="flex flex-row justify-center gap-3 m-2">
				<RouteButton route={"/main_menu"} text="Back" />
			</div>
		</>
	);
}

